import { computed, makeObservable } from "mobx";
import { BaseSyncModel } from "@/store/sync/BaseSyncModel";
import { SyncModelKind } from "@/store/sync/types";
import { WithAppStore } from "@/store/types";
import { SessionModelData } from "./types";
import { SyncUpdateValue } from "@/store/sync/types";
import { SessionEventListObservable } from "@/store/sessions/SessionEventListObservable";
import { SessionEventObservable } from "@/store/sessions/SessionEventObservable";

export class SessionObservable extends BaseSyncModel<SessionModelData> {
  public modelKind = SyncModelKind.Session;
  eventList: SessionEventListObservable;

  constructor({
    id,
    data,
    store,
  }: { id: string; data: SyncUpdateValue<SessionModelData> } & WithAppStore) {
    super({ id, data, store });
    this.eventList = new SessionEventListObservable({ sessionId: id, store });

    makeObservable(this, {
      eventList: true,
      lastUserActionAt: true,
      ownerLastSeenEventAt: true,
      modelKind: false,

      title: computed,
      status: computed,
      kind: computed,
      firstEvent: computed,
      latestEvent: computed,
      firstEventAt: computed,
      latestEventAt: computed,
    });
  }

  get title() {
    return this.modelData.title ?? null;
  }

  get status() {
    return this.modelData.status ?? null;
  }

  get kind() {
    return this.modelData.kind ?? null;
  }

  get lastUserActionAt() {
    return this.modelData.last_user_action_at ?? null;
  }

  get ownerLastSeenEventAt() {
    return this.modelData.owner_last_seen_event_at ?? null;
  }

  get firstEvent(): SessionEventObservable | undefined {
    return this.eventList.allSessionEvents[0];
  }

  get latestEvent() {
    return this.eventList.allSessionEvents.at(-1);
  }

  get firstEventAt() {
    return this.firstEvent?.locallyCreatedAt;
  }

  get latestEventAt() {
    return this.latestEvent?.locallyCreatedAt;
  }
}
